import { useLazyQuery } from '@apollo/client';

import { Arrayable } from '../../../helper/array';
import {
  MasterDataPeople,
  MasterDataPersonFilterInput,
  MasterDataPersonOrderByInput,
} from '../models/MasterDataPerson';
import { GET_PEOPLE } from './query';

interface QueryData {
  masterDataPeople: MasterDataPeople;
}

interface QueryVars {
  orderBy?: Arrayable<MasterDataPersonOrderByInput>;
  where?: Pick<MasterDataPersonFilterInput, '_id'>;
}

/**
 * Fetch people matching the given externalUserIds
 */
function useFetchPeople() {
  const [execute, { loading, error, data, refetch, called }] = useLazyQuery<QueryData, QueryVars>(GET_PEOPLE, {
    notifyOnNetworkStatusChange: true,
  });

  const fetchPeople = async (externalUserIds?: string[]) => {
    const variables = {
      orderBy: {
        displayName: 'ASC',
      },
      where: {
        ...(externalUserIds && {
          _id: { _in: externalUserIds },
        }),
      },
    } satisfies QueryVars;

    const response = called
      ? await refetch(variables)
      : await execute({
          variables,
        });

    return response.data?.masterDataPeople ?? [];
  };

  return {
    fetchPeople,
    loading,
    error,
    people: data?.masterDataPeople ?? [],
  };
}

export default useFetchPeople;
